import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { Col, TextBody } from '../../atoms';
import { BucketImage } from '../bucket-image';
export const NotaBeneLogo = memo(() => {
    return (_jsxs(Col.C, { children: [_jsx(TextBody, { mb: "2", children: "Powered by" }), _jsx(BucketImage, { path: "travel-rule/nota-bene-logo.png", width: 100, height: 21 })] }));
});
